import { InvoicesDataGridBase } from "./InvoicesDataGridBase";

export interface AllInvoicesDataGridProps {}

export const AllInvoicesDataGrid = ({}: AllInvoicesDataGridProps) => {
	return <InvoicesDataGridBase />;
};
